export const INTERNATIONAL = 'international';
export const INTL_ECOM_SPEND_LIMIT = 'intl_ecom_spend_limit';
export const INTL_POS_SPEND_LIMIT = 'intl_pos_spend_limit';
export const INTL_NFC_SPEND_LIMIT = 'intl_nfc_spend_limit';
export const INTL_ATM_SPEND_LIMIT = 'intl_atm_spend_limit';
